import route from "mock/route";

/**
 * @see https://umijs.org/docs/max/access#access
 */
export default function access(initialState: { currentUser?: API.CurrentUser; userMenus?: API.MenuItem[] } | undefined) {
  const { currentUser, userMenus = [] } = initialState ?? {};
  console.log(currentUser)
  let menus: any[] = []
  userMenus.forEach((menu) => {
    menus.push(menu.path)
    if (menu.children) {
      menu.children.forEach((child) => {
        menus.push(child.path)
      })
    }
  })
  console.log(menus)

  return {
    // 统一的权限函数，所有路由都使用这个
    showRoute: (route: any) => {
      return true
    },
  };
}
